import React, { useState, useEffect } from 'react';
import { LINKS_DO_FOLLOW_WHITE_LIST } from '@/utils/constants';

type LinkProps = {
  item: {
    url: string;
  };
  children: [];
  isExternal: boolean;
};

export default function Link({ item, children, isExternal = false }: LinkProps) {
  const [url, setUrl] = useState(item.url);
  const [target, setTarget] = useState('_blank');
  const isInWhiteList = Boolean(
    LINKS_DO_FOLLOW_WHITE_LIST.filter((link) => {
      return item.url.startsWith(link);
    }).length
  );

  useEffect(() => {
    const pathname = `${location.origin}${location.pathname}`;

    if (item.url.startsWith(pathname)) {
      setTarget('_self');
      setUrl(item.url.replace(pathname, ''));
    }
  }, []);

  return isExternal ? (
    isInWhiteList ? (
      <a href={url} target={target} rel="noreferrer noopener">
        {children}
      </a>
    ) : (
      <a href={url} target={target} rel="noreferrer noopener nofollow">
        {children}
      </a>
    )
  ) : (
    <a href={url} target={target} rel="noreferrer">
      {children}
    </a>
  );
}
